import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { captchaFetch } from './utils'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://269309a9fbecdb63e82122084fe22234@o4508834724315136.ingest.de.sentry.io/4508834726084688",
  environment: import.meta.env.VITE_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


declare global {
  interface Window {
    AwsWafIntegration: any
    AwsWafCaptcha: any
    fetch: any
    shouldShowCaptcha: boolean
  }
}

window.fetch = new Proxy(window.fetch, {
  apply: async function (target, that, args) {
    const modalOverlay = document.getElementById('modalOverlay')
    if (args[0]?.href?.includes('cognito') && modalOverlay) {
      if (window.AwsWafIntegration) {
        let token
        if (window.shouldShowCaptcha) token = await captchaFetch()
        else token = await window.AwsWafIntegration.getToken()
        args[1].headers['x-aws-waf-token'] = token
      }
    }

    return target.apply(that, args)
  },
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)